import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { createClient } from '../services/api';
import type { AxiosInstance } from 'axios';

export function useApi(): AxiosInstance {
  const { getToken, anonSessionId } = useAuth();
  return useMemo(() => createClient(getToken, anonSessionId), [getToken, anonSessionId]);
}
